import Toastify from "toastify-js";

export default function initShare() {
    document.querySelectorAll(".share").forEach((button) => {
        button.addEventListener("click", async (e) => {
            e.preventDefault();

            const title = button.dataset.title || document.title;
            const text = button.dataset.text || "";
            const url = button.dataset.url || location.href;

            const shareData = { title, text, url };

            if (navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    console.error("Share error:", err);
                }
            } else if (navigator.clipboard) {
                try {
                    await navigator.clipboard.writeText(url);
                    Toastify({
                        text: button.dataset.copiedMessage || "Link copied!",
                        duration: 3000,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                        style: {
                            background: "rgba(var(--smoke-rgb), 0.5)",
                            color: "black",
                        },
                    }).showToast();
                } catch (err) {
                    console.error("Clipboard error:", err);
                }
            }
        });
    });
}
